export default __webpack_public_path__ + "static/media/img-31-sahir.16093942.jpg";